import React, { Component } from 'react'
import RouteUnlessAuthenticated from './components/RouteUnlessAuthenticated'
import { Redirect, Route, Switch } from 'react-router-dom'
import WhenRestored from 'components/WhenRestored'
import RouteHome from './routes/home'
import RouteLogin from './routes/login'
import RouteLogout from './routes/logout'
import RouteAdmin from './routes/admin'
import RouteErrors from './routes/errors'
import RouteSignUp from './routes/sign-up'
import RouteIfAdmin from 'components/RouteIfAdmin'
import GoogleAnalytics from 'components/GoogleAnalytics'
import CurrentUserProvider from 'components/CurrentUser/Provider'
import NullComponent from 'components/NullComponent'
import { Notifications } from 'stylist'

class App extends Component {
  render() {
    return (
      <WhenRestored>
        <GoogleAnalytics {...this.props} />
        <Notifications />
        <Route path="/logout" component={RouteLogout} />
        <CurrentUserProvider>
          <Switch>
            <Route path="/" exact component={RouteHome} />
            <Route path="/my-focusvision" render={() => <Redirect to="/" />} />
            <Route path="/login" component={RouteLogin} />
            <Route path="/logout" component={NullComponent} />
            <RouteIfAdmin
              path="/admin"
              failRedirect="/"
              component={RouteAdmin}
            />
            <RouteUnlessAuthenticated
              to="/"
              path="/sign-up"
              component={RouteSignUp}
            />
            <Route path="/*" component={RouteErrors} />
          </Switch>
        </CurrentUserProvider>
      </WhenRestored>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js